export default __webpack_public_path__ + "static/media/loop-mail.e8d37f37.png";